"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Country_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var StatesProvince_1 = require("./StatesProvince");
var Country_Factory = /** @class */ (function () {
    function Country_Factory() {
    }
    Country_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AddressFormat: model.AddressFormat,
            CountryCode: model.CountryCode,
            CountryId: model.CountryId,
            CountryName: model.CountryName,
            StatesProvinces: model.StatesProvinces && model.StatesProvinces.map(function (i) { return StatesProvince_1.StatesProvince_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    Country_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AddressFormat: model.AddressFormat,
            CountryCode: model.CountryCode,
            CountryId: model.CountryId,
            CountryName: model.CountryName,
            StatesProvinces: model.StatesProvinces && model.StatesProvinces.map(function (i) { return StatesProvince_1.StatesProvince_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return Country_Factory;
}());
exports.Country_Factory = Country_Factory;
